module.exports = "https://static.energy5.com/_next/static/images/selectionImage-eff2a0676a03e6f75de4f72ef684546c.jpg";